export default __webpack_public_path__ + "static/banner.morf-1e116e791457f473d053c669c369ccf4.jpg";